import React, {useState} from "react";
import {
    notification,
    Popconfirm, Typography
} from 'antd';
import {Redirect} from "react-router-dom";
import {APIRequest} from "../shared/APIRequest";

const ContractorDelete = (props) => {

    const [redirect, setRedirect] = useState(false);


    if (redirect) {
        return <Redirect to='/contractor'/>
    }

    return (
        <>
            <Popconfirm
                title="Czy na pewno usunąć tego kontrahenta ?"
                onConfirm={() => {
                    APIRequest.delete('contractor/' + props.id, () => {
                        notification.success({
                            message: 'Usunięto kontrahenta.'
                        });
                        setRedirect(true);
                    });
                }}
                okText="Tak"
                cancelText="Nie"
                placement="topRight"
            >
                <Typography.Text type="danger" className="clickable" underline>usuń kontrahenta</Typography.Text>

            </Popconfirm>
        </>
    );
};

export {ContractorDelete as default}